<main id="freemium-page">
  <section id="form">
    <div class="container">
      <a class="svg-logo" target="_blank" href="https://worlddata.pro"
        ><svg
          width="62.13"
          height="48"
          viewBox="0 0 62.13 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M47.743 11.8152C50.9421 11.8152 53.5355 9.17024 53.5355 5.90758C53.5355 2.64491 50.9421 0 47.743 0C44.5439 0 41.9506 2.64491 41.9506 5.90758C41.9506 9.17024 44.5439 11.8152 47.743 11.8152Z"
            fill="#8AABFF"
          />
          <path
            d="M46.2295 47.6466C46.7097 47.8619 47.2287 47.9731 47.7533 47.9731C48.2779 47.9731 48.7969 47.8619 49.2771 47.6466C49.9271 47.3557 50.4517 46.8344 50.7536 46.1793L50.8861 45.909L61.676 19.4987C61.676 19.4987 63.9286 14.2089 58.439 15.6375C58.439 15.6375 47.3842 21.4293 36.7458 15.4831L36.3293 15.29C35.4775 15.0583 32.7895 14.5564 33.471 18.2438C33.4911 18.3835 33.5293 18.5198 33.5845 18.6492L44.6015 45.8897C44.7006 46.1036 44.8144 46.3101 44.9423 46.5075C45.2163 47.0382 45.6756 47.4447 46.2295 47.6466Z"
            fill="#8AABFF"
          />
          <path
            d="M14.5225 11.8152C17.7216 11.8152 20.315 9.17024 20.315 5.90758C20.315 2.64491 17.7216 0 14.5225 0C11.3235 0 8.7301 2.64491 8.7301 5.90758C8.7301 9.17024 11.3235 11.8152 14.5225 11.8152Z"
            fill="white"
          />
          <path
            d="M15.9042 15.4242C15.4239 15.2089 14.905 15.0977 14.3804 15.0977C13.8557 15.0977 13.3368 15.2089 12.8565 15.4242C12.2039 15.7011 11.6769 16.2179 11.38 16.8722L11.2475 17.1425L0.457692 43.63C0.457692 43.63 -1.79492 48.9198 3.69464 47.4912C3.69464 47.4912 14.7495 41.6994 25.3879 47.6456C25.5173 47.7292 25.6575 47.7942 25.8044 47.8387C26.6562 48.0704 29.3442 48.5723 28.6627 44.8849C28.6452 44.7509 28.6068 44.6205 28.5491 44.4988L17.5321 17.1811C17.4331 16.9671 17.3192 16.7607 17.1914 16.5633C16.9117 16.0372 16.4544 15.6324 15.9042 15.4242Z"
            fill="white"
          />
        </svg>
      </a>

      <h1>Welcome to World Data Pro <span>Freemium</span></h1>

      <div class="form-container unavailable">
        <mpro-mobile-unavailable></mpro-mobile-unavailable>
      </div>

      <div class="form-container register" *ngIf="registryStep === 'USER'">
        <form [formGroup]="form" (ngSubmit)="onUserDataSubmit()">
          <div formGroupName="userData">
            <div class="row">
              <div class="col-6 p-0 m-0 holder">
                <input
                  type="text"
                  formControlName="firstName"
                  class="form-control"
                  [class.error]="
                    form.get('userData')?.get('firstName')?.errors &&
                    userDataConfirmed
                  "
                  id="first-name"
                  placeholder="First Name"
                />
                <p
                  class="error"
                  *ngIf="
                    form.get('userData')?.get('firstName')?.errors &&
                    userDataConfirmed
                  "
                >
                  Please fill in your first name.
                </p>
              </div>
              <div class="col-6 p-0 m-0 holder">
                <input
                  type="text"
                  formControlName="lastName"
                  class="form-control"
                  [class.error]="
                    form.get('userData')?.get('lastName')?.errors &&
                    userDataConfirmed
                  "
                  id="last-name"
                  placeholder="Last Name"
                />
                <p
                  class="error"
                  *ngIf="
                    form.get('userData')?.get('lastName')?.errors &&
                    userDataConfirmed
                  "
                >
                  Please fill in your last name.
                </p>
              </div>
            </div>
            <div class="holder">
              <input
                type="text"
                formControlName="organizationName"
                class="form-control"
                [class.error]="
                  form.get('userData')?.get('organizationName')?.errors &&
                  userDataConfirmed
                "
                id="company-name"
                placeholder="Company Name"
              />
              <p
                class="error"
                *ngIf="
                  form.get('userData')?.get('organizationName')?.errors &&
                  userDataConfirmed
                "
              >
                Please fill in your company name.
              </p>
            </div>
            <div class="holder">
              <input
                type="text"
                formControlName="email"
                class="form-control"
                [class.error]="
                  form.get('userData')?.get('email')?.errors &&
                  userDataConfirmed
                "
                id="company-email"
                placeholder="Business Email"
              />
              <p
                class="error"
                *ngIf="
                  form.get('userData')?.get('email')?.errors &&
                  userDataConfirmed
                "
              >
                Please fill in your business email.
              </p>
            </div>
            <div class="holder">
              <input
                type="number"
                formControlName="phoneNumber"
                class="form-control"
                [class.error]="
                  form.get('userData')?.get('phoneNumber')?.errors &&
                  userDataConfirmed
                "
                id="company-phoneNumber"
                placeholder="Phone Number"
              />
              <p
                class="error"
                *ngIf="
                  form.get('userData')?.get('phoneNumber')?.errors &&
                  userDataConfirmed
                "
              >
                Please fill in your phone number.
              </p>
            </div>

            <div class="form-check">
              <mpro-checkbox
                formControlName="contactMe"
                label="Yes, I’m OK with receiving marketing communications about World Data Pro. If I change my mind, I can unsubscribe at any time."
                class="form-check-input"
              ></mpro-checkbox>
            </div>
          </div>
          <button
            type="submit"
            id="submit-btn"
            [class.active]="form.get('userData')?.valid"
          >
            NEXT
          </button>
        </form>
      </div>
      <div
        class="form-container register mobile-hidden"
        *ngIf="registryStep === 'CATEGORY'"
      >
        <mpro-loading *ngIf="loading"></mpro-loading>
        <div>
          <button class="mpro-btn mpro-btn-tertiary" (click)="stepBack()">
            <fa-icon [icon]="faArrowLeft"></fa-icon>
          </button>
          <h2>Please choose a category of your interest</h2>
        </div>
        <form (ngSubmit)="onSubmit()">
          <div class="category-list mb-4">
            <mpro-checkable-dropdown-item
              *ngFor="let c of categories"
              [leftText]="c.label"
              [checked]="isChecked(c)"
              (itemChecked)="onCategorySelected(c, $event)"
            >
            </mpro-checkable-dropdown-item>
          </div>
          <button
            type="submit"
            id="submit-btn"
            [class.active]="form.get('categorySelector')?.valid"
          >
            TRY FOR FREE
          </button>
        </form>
      </div>
      <div
        class="form-container success register"
        *ngIf="registryStep === 'SUCCESS'"
      >
        <h2>Thank you for signing up!</h2>
        <p class="align-center">
          To complete the registration process and verify your identity, please
          check your email inbox for a message from us.
        </p>
        <mpro-curve-background-animation></mpro-curve-background-animation>
      </div>
      <div
        class="form-container errorContainer register"
        *ngIf="registryStep === 'ERROR'"
      >
        <h2>Oops!</h2>
        <p *ngIf="emailAlreadyInUse" class="align-center">
          The email <b>{{ form.get("userData")?.get("email")?.value }}</b> is
          already associated with an existing account. Please sign in instead.
          If you forgot your password, use the 'Forgot Password' option on the
          login page. For further help, contact our support team. Thank you!
        </p>
        <p *ngIf="userExists" class="align-center">
          The email <b>{{ form.get("userData")?.get("email")?.value }}</b> is
          already associated with an existing account but the identity wasn't
          verified. Please check your email for the identity verification
          request. For further help, contact our support team. Thank you!
        </p>
        <p *ngIf="!emailAlreadyInUse && !userExists">
          Something went wrong! For further help, contact our support team.
          Thank you!
        </p>
        <mpro-curve-background-animation></mpro-curve-background-animation>
        <div class="buttons">
          <button class="mpro-btn mpro-btn-primary" (click)="redirectLogIn()">
            LOGIN
          </button>
          <button class="mpro-btn mpro-btn-secondary" (click)="resetForm()">
            USE NEW EMAIL
          </button>
        </div>
      </div>
    </div>

    <hr class="divid" />

    <footer>
      <p class="copyrights">Copy rights to World Data Lab {{ currentYear }}</p>
      <div class="links">
        <a target="_blank" href="https://worlddata.io/who-we-are">About us</a>
        <a target="_blank" href="https://worlddata.io/blog">Blog</a>
        <a target="_blank" href="https://worlddata.io/">Privacy Policy</a>
        <a target="_blank" href="https://worlddata.io/">Terms of Use</a>
      </div>
    </footer>
  </section>
</main>
